import React, { useState } from 'react';
import PropTypes from 'prop-types';
import btnFocus from '../../assets/images/btn_google_signin_dark_focus_web.png';
import btn from '../../assets/images/btn_google_signin_dark_normal_web.png';
import './styles.css';

const GoogleButton = props => {
  const { controlFunc } = props;

  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  return (
    <a
      className="google-button"
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onMouseOver={hoverOn}
      onMouseOut={hoverOff}
      onMouseUp={hoverOn}
      onMouseDown={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
      onClick={controlFunc}
    >
      <img
        className="google-button__img"
        src={hover ? btnFocus : btn}
        alt="Sign in with Google"
      />
    </a>
  );
};

GoogleButton.propTypes = {
  controlFunc: PropTypes.func,
};

export default GoogleButton;
